import { tenantUiHttpApi } from "../api";
import { toTenantUiSettings } from "./tenantUiMappers";
import type { TenantUiSettings } from "./tenantUi.types";

/** GET /tenant/ui-settings, mapped. Rejects on HTTP errors; callers decide the fallback. */
export const fetchTenantUiSettings = async (): Promise<TenantUiSettings> =>
  toTenantUiSettings(await tenantUiHttpApi.getSettings());
